<template>
        <div class="abilitiesBlock">
            <tapered-rule></tapered-rule>
                <table>
                <tr>
                    <th>STR</th>
                    <th>DEX</th>
                    <th>CON</th>
                    <th>INT</th>
                    <th>WIS</th>
                    <th>CHA</th>
                </tr>
                <tr>
                    <td class="score" ref="str_score" contenteditable="true"  readonly
                        @blur="enableScroll" 
                        @focus="disableScroll"
                        @keydown.up="updateScore(1,0)"
                        @keydown.down="updateScore(-1,0)">
                        {{formatScore(data_str)}}
                    </td>
                    <td class="score" ref="dex_score" contenteditable="true" readonly
                        @blur="enableScroll" 
                        @focus="disableScroll"
                        @keydown.up="updateScore(1,1)"
                        @keydown.down="updateScore(-1,1)">
                        {{formatScore(data_dex)}}
                    </td>
                    <td class="score" ref="con_score" contenteditable="true" readonly
                        @blur="enableScroll" 
                        @focus="disableScroll"
                        @keydown.up="updateScore(1,2)"
                        @keydown.down="updateScore(-1,2)">
                        {{formatScore(data_con)}}
                    </td>
                    <td class="score" ref="int_score" contenteditable="true" readonly
                        @blur="enableScroll" 
                        @focus="disableScroll"
                        @keydown.up="updateScore(1,3)"
                        @keydown.down="updateScore(-1,3)">
                        {{formatScore(data_int)}}
                    </td>
                    <td class="score" ref="wis_score" contenteditable="true" readonly
                        @blur="enableScroll" 
                        @focus="disableScroll"
                        @keydown.up="updateScore(1,4)"
                        @keydown.down="updateScore(-1,4)">
                        {{formatScore(data_wis)}}
                    </td>
                    <td class="score" ref="cha_score" contenteditable="true" readonly
                        @blur="enableScroll" 
                        @focus="disableScroll"
                        @keydown.up="updateScore(1,5)"
                        @keydown.down="updateScore(-1,5)">
                        {{formatScore(data_cha)}}
                    </td>
                </tr>
                </table>
            <tapered-rule></tapered-rule>  
        </div>
</template>

<script>
import taperedRule from './taperedRule.vue';

export default {
    name: 'abilitiesBlock',
    props: {
        score_str: Number,
        score_dex: Number,
        score_con: Number,
        score_int: Number,
        score_wis: Number,
        score_cha: Number
    },
    components:{
        taperedRule
    },
    data(){
        return {
            isUp : false,
            isFocused : false,
            ABILITY_SCORES : {0 : 'str', 1 : 'dex', 2 : 'con', 3 : 'int', 4 : 'wis', 5 : 'cha'},
            data_str : this.score_str,
            data_dex : this.score_dex,
            data_con : this.score_con,
            data_int : this.score_int,
            data_wis : this.score_wis,
            data_cha : this.score_cha,
        }
    },
    methods:{
        formatScore:function(abilityScore){
            var score = parseInt(abilityScore, 10);
            var abilityMod = Math.floor((score-10)/2);
            
            var modSign = ""
            if(abilityMod >=0){
                modSign = "+";
            }else{
                modSign="-";
            }

            var text = abilityScore + ' (' + modSign + String(Math.abs(abilityMod)) + ')';
            return text;
        },
        onScroll_str(e){this.onScroll(e, 0)},
        onScroll_dex(e){this.onScroll(e, 1)},
        onScroll_con(e){this.onScroll(e, 2)},
        onScroll_int(e){this.onScroll(e, 3)},
        onScroll_wis(e){this.onScroll(e, 4)},
        onScroll_cha(e){this.onScroll(e, 5)},
        onScroll(event, ABILITY){
            if (event.deltaY < 0){
                console.log('scrolling up');
                this.isUp = true;
                // document.getElementById('status').textContent= 'scrolling up';
            }else if (event.deltaY > 0){
                console.log('scrolling down');
                this.isUp = false;
                // document.getElementById('status').textContent= 'scrolling down';
            }

            if(this.isUp){
                // increment
                this.updateScore(1, ABILITY)
            }else{
                // decrement
                this.updateScore(-1, ABILITY)
            }
        },
        updateScore(increment, ABILITY){
            switch (ABILITY) {
                case 0:
                    this.data_str += increment;
                    break;
                case 1:
                    this.data_dex += increment;
                    break;
                case 2:
                    this.data_con += increment;
                    break;
                case 3:
                    this.data_int += increment;
                    break;
                case 4:
                    this.data_wis += increment;
                    break;
                case 5:
                    this.data_cha += increment;
                    break;
            
                default:
                    console.log(ABILITY);
                    break;
            }
        },
        disableScroll(){
            this.isFocused = false;
            document.documentElement.style.overflow = 'hidden';
        },
        enableScroll(){
            this.isFocused = true;
            document.documentElement.style.overflow = 'auto';
        },
    },
    mounted(){
        this.$refs.str_score.addEventListener('wheel', this.onScroll_str);
        this.$refs.dex_score.addEventListener('wheel', this.onScroll_dex);
        this.$refs.con_score.addEventListener('wheel', this.onScroll_con);
        this.$refs.int_score.addEventListener('wheel', this.onScroll_int);
        this.$refs.wis_score.addEventListener('wheel', this.onScroll_wis);
        this.$refs.cha_score.addEventListener('wheel', this.onScroll_cha);
    },
}
</script>

<style>
  table {
    width: 100%;
    border: 0px;
    border-collapse: collapse;
  }
  th, td {
    width: 50px;
    text-align: center !important;
  }

  td:hover{
    background-color: white;
  }
  .score:hover{
    background-color: white;
  }


  html, body {
      /* margin: 0;  */
      /* height: 100%;  */
      /* overflow: hidden; */
  }
</style>